import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { Mail } from 'src/app/shared/models/mails/mail';
import { UntypedFormGroup } from '@angular/forms';
import { Scan } from 'src/app/shared/models/iCourrier/scans/scan';
import { DataService } from 'src/app/shared/services/data.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { IButton, TranslateService } from '@devinforius/i-essentials';

@Component({
  selector: 'app-courrier-create-modal',
  templateUrl: './courrier-create-modal.component.html',
  styleUrls: ['./courrier-create-modal.component.scss'],
})
export class CourrierCreateModalComponent implements OnInit {
  public globalSubmitESubject: Subject<void> = new Subject<void>();
  public isFormSubmit: boolean;
  public isDisabled: boolean;
  public btnTooltip: string;
  public canSubmit: boolean;
  public form: UntypedFormGroup;
  public origin: string; // for confirm modal
  public scan?: Scan;
  public linkMailId?: number; // if it's new mail with scan linked to another mail

  //  Fields for answer
  public isAnswerMode: boolean;
  public mailId: number;
  public courrier: Mail;
  public expediteurId: number; // expediteur become destinataire
  public expediteurIdiAdmin: number; // expediteur become destinataire
  public defaultTypeES: string;

  public mailType: string; // for typeEntrantSortant
  public serviceProprietaireId: number; // service prop of the scan
  public courrierFile;
  public isFormValid: boolean = false;
  public receivedMail: Mail;

  public titleButtons: IButton[] = [
    {
      text: 'global.quit',
      styleClass: 'blue',
      click: () => {
        this.close();
      },
    },
    {
      text: 'register',
      styleClass: 'green',
      id: 'btnCourrierCreateSubmit',
      disabled: !this.isFormValid,
      click: () => {
        this.onSubmit();
      },
    },
  ];

  constructor(
    public confirmationService: ConfirmationService,
    public dataService: DataService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private translater: TranslateService
  ) {}

  ngOnInit(): void {
    this.titleButtons = this.titleButtons.map((button) => ({ ...button, text: this.translater.translate(button.text) }));

    if (this.config && this.config.data) {
      this.mailType = this.config.data.mailType ? this.config.data.mailType : null;
      this.origin = this.config.data.origin ? this.config.data.origin : null;
      this.courrierFile = this.config.data.courrierFile ? this.config.data.courrierFile : null;
      this.mailId = this.config.data.mailId ? this.config.data.mailId : null;
      if (this.mailId) {
        sessionStorage.setItem('oldCourrier', this.mailId.toString());
      }
      this.courrier = this.config.data.mail ? this.config.data.mail : null;
      this.expediteurId = this.config.data.expediteurId ? this.config.data.expediteurId : null;
      this.expediteurIdiAdmin = this.config.data.expediteurIdiAdmin ? this.config.data.expediteurIdiAdmin : null;
      this.defaultTypeES = this.config.data.defaultTypeES ? this.config.data.defaultTypeES : null;
      this.isAnswerMode = this.config.data.isAnswerMode ? this.config.data.isAnswerMode : null;
    }
  }

  public close(): void {
    if (this.form?.dirty && !this.isFormSubmit) {
      this.confirmationService.confirm({
        message: 'Si vous quittez maintenant vous allez perdre vos changements, voulez-vous continuer?',
        icon: 'bi bi-exclamation-triangle',
        accept: () => {
          this.ref.close();
        },
        key: 'CloseModal',
      });
    } else {
      this.ref.close();
    }
  }

  public canSubmitReceived(canSubmit: boolean): void {
    if (canSubmit === true) {
      this.canSubmit = true;
    } else {
      this.canSubmit = false;
    }
  }

  public onSubmit(): void {
    this.globalSubmitESubject.next();

    if (this.mailType === 'S') {
      sessionStorage.setItem('showModalDestinataire', '1');
    }
    sessionStorage.removeItem('createFromFile');
    this.dataService.setCurrentAttachement(null);
  }

  public receiveNewMail(mail: Mail): void {
    this.receivedMail = mail;

    if (this.receivedMail.typeEntrantSortant === 'S') {
      sessionStorage.setItem('showModalDestinataire', '1');
    }

    this.ref.close(mail);
  }

  // To see if form is dirty and not submit for back btn
  public receiveFormState(formState: { form: UntypedFormGroup; isFormSubmit: boolean }): void {
    if (formState) {
      this.form = formState.form;
      this.isFormSubmit = formState.isFormSubmit;
    }
  }

  public receiveFormValidSt(isFormValid: boolean): void {
    this.isFormValid = isFormValid;
    this.titleButtons[1].disabled = !isFormValid;
  }
}
